import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        minHeight: '350px',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '3rem 2rem'
    },
    detailContainer: {
        paddingTop: '2.25rem',
        '&:first-child': { paddingTop: '0' }
    },
    statusIcon: {
        marginRight: '.75rem',
        '&:last-child': { marginRight: 0 }
    },
    assetTag: { margin: '.2rem' },
    detailLabel: {
        fontSize: '.75rem',
        color: theme?.app?.applicationColors.fontLabelColor ||
            '#727272',
        fontWeight: 'bold' as const,
        textTransform: 'uppercase' as const,
        paddingBottom: '.3rem'
    },
    detailText: { fontSize: '1.2rem' },
    firmActionButtonsContainer: { width: 'auto' as const },
    closedTag: {
        height: 'fit-content' as const,
        alignSelf: 'center' as const,
        marginRight: '.5rem'
    },
    actionButton: {
        marginLeft: '.5rem',
        '&:first-child': { marginLeft: '0' }
    },
    createdText: {
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        fontSize: '.8rem'
    },
    noNotes: {
        color: theme?.app?.applicationColors.enumColors.greyLighter ||
            '#cfcfcf'
    },
    boldText: { fontWeight: 'bold' as const }
});